import script from "./CRM10_024RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM10_024RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM10_024RPT.vue?vue&type=style&index=0&id=f335f1f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f335f1f0"]])

export default __exports__